<template>
  <transition name="slide-fade">
    <div v-if="showToast">
      <div :class="notification.type" aria-atomic="true">
        <div class="toast-icon"></div>
        <div class="toast-message">
          <p>
            <span class="sr-only">{{ notification.messageType }}</span>
            <strong id="notification-info-heading">{{
              notification.heading
            }}</strong>
          </p>
          <p>{{ notification.message }}</p>
          <button
            class="toast-close"
            aria-describedby="notification-info-heading"
            @click.prevent="removeNotification">
            Luk
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { StandardEmitEvents } from '@/types/enums/standardEmitEvents.enum';
import type { Notification } from '@/types/models/notification.model';

const props = defineProps({
  notification: { type: Object as PropType<Notification>, required: true }
});

const emit = defineEmits([StandardEmitEvents.CLOSE]);

const showToast = ref(true); // This controls the visibility of the toast

const removeNotification = () => {
  showToast.value = false; // Hide the toast
  setTimeout(() => {
    emit(StandardEmitEvents.CLOSE, props.notification); // Emit after a small delay to let transition finish
  }, 300);
};
</script>

<style scoped>
/* Transition */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-to,
.slide-fade-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
</style>
